<template>
  <div>
    <div class="row">
      <div class="col-md-10"></div>
      <div class="col-md-2"></div>
    </div>
    <div class="col-md-12">
      <h4>Meu Perfil</h4>
    </div>
    <div class="col-md-12" >
      <div class="card" style="margin-top:20px;">
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">Nome: {{exibir.name}}</div>
          </div>
          <div class="row">
            <div class="col-md-12">Email: {{exibir.email}}</div>
          </div>
          <div class="row" v-if="exibir.cpf">
            <div class="col-md-12" v-if="exibir.cpf.length ==11">CPF: 
              {{exibir.cpf[0]+exibir.cpf[1]+exibir.cpf[2]+"."+exibir.cpf[3]+exibir.cpf[4]+exibir.cpf[5]+"."+
              exibir.cpf[6]+exibir.cpf[7]+exibir.cpf[8]+"-"+exibir.cpf[9]+exibir.cpf[10]}}
            </div>
            <div class="col-md-12" v-if="exibir.cpf.length ==10">CPF: 
              {{exibir.cpf[0]+exibir.cpf[1]+exibir.cpf[2]+"."+exibir.cpf[3]+exibir.cpf[4]+exibir.cpf[5]+"."+
              exibir.cpf[6]+exibir.cpf[7]+exibir.cpf[8]+"-"+exibir.cpf[9]}}
            </div>
          </div>
          <div class="row" v-if="exibir.cnpj">
            <!--66.469.313/0001-00-->
            <div class="col-md-12">CNPJ: 
              {{exibir.cnpj[0]+exibir.cnpj[1]+"."+exibir.cnpj[2]+exibir.cnpj[3]+exibir.cnpj[4]+"."+exibir.cnpj[5]+exibir.cnpj[6]+exibir.cnpj[7]+"/"+
              exibir.cnpj[8]+exibir.cnpj[9]+exibir.cnpj[10]+exibir.cnpj[11]+"-"+exibir.cnpj[12]+exibir.cnpj[13]}}
            </div>
          </div>
          <div class="row" v-if="exibir.telefone">
            <div class="col-md-12">Telefone: {{exibir.telefone}}</div>
          </div>
          <div class="row" v-if="exibir.bairro">
            <div class="col-md-12">Bairro: {{exibir.bairro}}</div>
          </div>
          <div class="row" v-if="exibir.rua">
            <div class="col-md-12">Rua: {{exibir.rua}}</div>
          </div>
          <div class="row" v-if="exibir.numero">
            <div class="col-md-12">Numero: {{exibir.numero}}</div>
          </div>
          <div class="row" v-if="exibir.complemento">
            <div class="col-md-12">Complemento: {{exibir.complemento}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12" v-if="msgAlterada">
      <div
        class="card"
        style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
        v-if="msg==1"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">{{msgAlterada}}</div>
          </div>
        </div>
      </div>
      <div
        class="card"
        style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
        v-if="msg==0"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-md-4">{{msgAlterada}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12" >
        <button
          type="button"
          class="btn btn-primary btn-fill float-left"
          @click.prevent="authsenha"
        >Editar senha</button>
    </div> 

    <!--<div class="col-md-12" v-if="e_senha==1">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Nova Senha</label>
            <input
              type="password"
              placeholder="Nova Senha"
              maxlength="250"
              v-model="cidadao.senha"
              class="form-control"
              :style="styleSenha"
            />
            <label
              class="control-label"
              v-if="styleSenha!=''"
              style="color:rgb(243 0 0);font-size: 12px;"
            >*Obrigatorio</label>
          </div>
        </div>
      </div>
    </div>-->
    <div class="col-md-12" v-if="e_endereco==1">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Bairro</label>
            <input
              type="text"
              placeholder="Novo Bairro"
              maxlength="250"
              v-model="exibir.bairro"
              class="form-control"

            />

          </div>
        </div>
        <div class="col-md-10">
          <div class="form-group">
            <label class="control-label">Rua</label>
            <input
              type="text"
              placeholder="Nova Rua"
              maxlength="250"
              v-model="exibir.rua"
              class="form-control"
            />
            
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="control-label">Numero</label>
            <input
              type="text"
              placeholder="Novo Numero"
              maxlength="250"
              v-model="exibir.numero"
              class="form-control"
            />

          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label class="control-label">Complemento</label>
            <input
              type="text"
              placeholder="Novo Complemento"
              maxlength="250"
              v-model="exibir.complemento"
              class="form-control"
            />

          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12" v-if="e_telefone==1" style="margin-bottom: 20px;">
       <label>Telefone Fixo</label>
           <the-mask
              placeholder="Telefone Fixo"
              class="form-control"
              :mask="['(##) ####-####']"
              v-model="exibir.telefone"
            />
    </div>

    <div class="col-md-12" v-if="e_celular==1" style="margin-bottom: 20px;">
       <label>Celular</label>
        <the-mask
              placeholder="Telefone Celular"
              class="form-control"
              :mask="['(##) #####-####']"
              v-model="exibir.celular"
            />  
    </div>
    
    
    
    
  </div>
</template>

<script>
import axios from "axios";
import store_cidadao from "src/storeCidadao.js"
import "src/controller/sistema/manifestacaoController.js";
import "src/controller/sistema/assuntoSecretariaController.js";
import "src/controller/sistema/usuarioController.js";
import "src/controller/sistema/cidadaoController.js";
import { TheMask } from "vue-the-mask";

export default {
  name: "perfilcidadao",
  components: {},
  props: {
    row: null,
  },
  data() {
    return {
      mask: "(00)00000-0000",
      exibir:{
        bairro:null,
        rua:null,
        complemento:null,
        numero:null,
        nome:null,
        email:null,
        cidadao: null,
        admin: null,
        status: null,
        id:null,
        id_cidadao:null,
        cpf:null,
        cnpj:null,
        telefone:null,
        celular:null,
      },
      e_senha: 0,
      e_endereco:0,
      e_telefone:0,
      e_celular:0,
      e_btn:1,
      cidadao: {
        senha: null,
      },
      msgAlterada: null,
      msg: null,
      styleSenha: "",
    };
  },
  methods: {
    authsenha(){
      this.$router.push({
            name: "enviarsenha",
            params: { email: this.exibir.email },
          });
    },
    
    async meuLogin() {
      try {
        //let data = await this.$meuLoginCidadao();
        let en = await this.$enderecoGet(store_cidadao.id_cidadao);
        let b1c = await this.$buscarUmCidadao(store_cidadao.id_cidadao);
        let tel = await this.$telefoneGet(store_cidadao.id_cidadao);

        if(en.data !=[]){
          this.exibir.bairro = en.data.bairro;
        }
        if(en.data !=[]){
          this.exibir.complemento =en.data.complemento;
        }
        if(en.data !=[]){
          this.exibir.numero = en.data.numero;
        }  
        if(en.data !=[]){
          this.exibir.rua = en.data.rua;
        }
        this.exibir.name = store_cidadao.nome;
        this.exibir.email = store_cidadao.email;  
        /*this.exibir.cidadao = data.cidadao; 
        this.exibir.admin = data.admin;*/
        this.exibir.status = store_cidadao.status;
        this.exibir.id =store_cidadao.id;
        this.exibir.id_cidadao =store_cidadao.id_cidadao;
        this.exibir.cpf = b1c.data.cpf;
        this.exibir.cnpj = b1c.data.cnpj;

        tel.data.forEach(element => {
          if(element.tipo == "Fixo"){
            this.exibir.telefone = element.telefone;
          }
          if(element.tipo == "Celular"){
            this.exibir.celular = element.telefone;
          }
        });

        
      } catch (error) {
         console.log(error);
      }
    },
    editar_endereco_option(){
      this.msgAlterada=null;
      this.e_senha = 0;
      this.e_celular = 0;
      this.e_endereco = 1;
      this.e_btn = 0;
    },
    editar_option() {
      this.msgAlterada=null;
      this.e_btn = 0;
      this.e_celular = 0;
      this.e_senha = 1;
      this.e_endereco = 0;
    },
    editar_telefone_option(){
      this.e_telefone = 1;
      this.e_celular = 0;
      this.e_senha = 0;
      this.e_endereco = 0;
      this.e_btn = 0;
    },
    editar_celular_option(){
      this.e_telefone = 0;
      this.e_celular = 1;
      this.e_senha = 0;
      this.e_endereco = 0;
      this.e_btn = 0;
    },
    cancelar() {
      this.msgAlterada=null;
      this.e_senha = 0;
      this.e_endereco = 0;
      this.e_btn = 1;
      this.e_telefone = 0;
      this.e_celular = 0;
    },
    async editar() {
      try {
        this.msgAlterada=null;
        if (this.cidadao.senha == null || this.cidadao.senha == "") {
          this.styleSenha = "border: 2px solid rgb(243 0 0);";
          this.msgAlterada = "O campo senha está Vazio!";
          this.msg = 0;
          return false;
        }
        let novo_cidadao = {
          senha: this.cidadao.senha,
          nome: this.exibir.name,
          email: this.exibir.email,
          cidadao: this.exibir.cidadao,
          admin: this.exibir.admin,
          status: this.exibir.status,
        };

        let data = await this.$usuarioEditar(novo_cidadao, this.exibir.id);
        this.cidadao.senha = null;
        if (data.data == "Editado com Sucesso!") {
          this.msgAlterada = "Sua Senha foi alterada Com Sucesso!";
          this.styleSenha ="";
          this.msg = 1;
        } else {
          this.msgAlterada = "Oops algo estranho aconteceu tente novamente!";
          this.msg = 0;
        }
      } catch (error) {}
    },
    async editarEndereco(){
      try {
        this.msgAlterada=null;
        let data = await this.$enderecoEdit(this.exibir.id_cidadao, this.exibir);
        if (data.data == "1") {
          this.msgAlterada = "Endereço alterado Com Sucesso!";
          this.styleSenha ="";
          this.msg = 1;
        }else{
          this.msgAlterada = "Oops algo estranho aconteceu tente novamente!";
          this.msg = 0;
        }  
        
      } catch (error) {
        console.log(error);
      }
    },
    async editarTelefone(tipo){
      try {
       
        if(tipo=="fixo"){
            this.msgAlterada=null;
            let data = await this.$telefoneEdit(this.exibir.id_cidadao, this.exibir.telefone,tipo);
            if (data.data == "1") {
              this.msgAlterada = "Telefone alterado Com Sucesso!";
              this.styleSenha ="";
              this.msg = 1;
            }else{
              this.msgAlterada = "Oops algo estranho aconteceu tente novamente!";
              this.msg = 0;
            } 
        }

        if(tipo=="celular"){
           this.msgAlterada=null;
            let data = await this.$telefoneEdit(this.exibir.id_cidadao, this.exibir.telefone,tipo);
            if (data.data == "1") {
              this.msgAlterada = "Celular alterado Com Sucesso!";
              this.styleSenha ="";
              this.msg = 1;
            }else{
              this.msgAlterada = "Oops algo estranho aconteceu tente novamente!";
              this.msg = 0;
            } 
        }
      }catch(error){

      }
    }  
  },
  beforeMount() {
    try {
      this.meuLogin();
      this.endereco(this.exibir.id_cidadao);
    } catch (e) {}
  },
};
</script>

